// import React, { useState } from "react";
// import { ChartColumn, Star, TrendingUp, Trophy, Users, X } from "lucide-react";

// export default function Sidebar() {
//   const [activeTab, setActiveTab] = useState("Team Report");
//   const [isCollapsed, setIsCollapsed] = useState(false);

//   const tabs = [
//     { name: "Team Report", icon: <ChartColumn className="h-5 w-5" /> },
//     { name: "Sales & Stats", icon: <Users className="h-5 w-5" /> },
//     { name: "Direct Sale Report", icon: <TrendingUp className="h-5 w-5" /> },
//     { name: "Win a Game", icon: <Trophy className="h-5 w-5" /> },
//     { name: "Reviews", icon: <Star className="h-5 w-5" /> },
//   ];

//   return (
//     <div
//       className={`px-4 py-8 bg-[#0B0F14] transition-all duration-300 ${
//         isCollapsed ? "w-20" : "w-64"
//       }`}
//     >
//       <div
//         className={`flex gap-4 mb-12 items-center ${
//           isCollapsed ? "justify-center" : "px-4"
//         }`}
//       >
//         <h1 className="bg-[linear-gradient(102.37deg,_#FBD150_0%,_#FAB938_100%)] bg-clip-text text-transparent text-2xl font-semibold">
//           {isCollapsed ? "D" : "Dashboard"}
//         </h1>

//         <button
//           onClick={() => setIsCollapsed(!isCollapsed)}
//           className="ml-auto"
//         >
//           <X className="text-gray-200 w-4 h-4" />
//         </button>
//       </div>

//       <div className="text-white text-lg space-y-4">
//         {tabs.map((tab) => (
//           <button
//             key={tab.name}
//             onClick={() => setActiveTab(tab.name)}
//             className={`flex items-center gap-4  justify-start px-4 py-2 rounded-lg w-full
//               ${
//                 activeTab === tab.name
//                   ? "bg-[linear-gradient(102.15deg,_#FBD150_0%,_#FAB938_100%)] text-black"
//                   : "text-gray-200"
//               }`}
//           >
//             {tab.icon}
//             {!isCollapsed && <p>{tab.name}</p>}
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// }
import React, { useState, useEffect } from "react";
import { ChartColumn, Star, TrendingUp, Trophy, Users, X } from "lucide-react";

export default function Sidebar() {
  const [activeTab, setActiveTab] = useState("Team Report");
  const [isCollapsed, setIsCollapsed] = useState(false);

  const tabs = [
    { name: "Team Report", icon: <ChartColumn className="h-5 w-5" /> },
    { name: "Sales & Stats", icon: <Users className="h-5 w-5" /> },
    { name: "Direct Sale Report", icon: <TrendingUp className="h-5 w-5" /> },
    { name: "Win a Game", icon: <Trophy className="h-5 w-5" /> },
    { name: "Reviews", icon: <Star className="h-5 w-5" /> },
  ];

  // Collapse sidebar on small and medium screens
  useEffect(() => {
    const handleResize = () => {
      setIsCollapsed(window.innerWidth < 1024);
    };
    handleResize(); // check on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className={`px-4 py-8 bg-[#0B0F14] transition-all duration-300 ${
        isCollapsed ? "w-20" : "w-64"
      }`}
    >
      <div
        className={`flex gap-4 mb-12 items-center ${
          isCollapsed ? "justify-center" : "px-4"
        }`}
      >
        <h1 className="bg-[linear-gradient(102.37deg,_#FBD150_0%,_#FAB938_100%)] bg-clip-text text-transparent text-2xl font-semibold">
          {isCollapsed ? "D" : "Dashboard"}
        </h1>

        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="ml-auto"
        >
          <X className="text-gray-200 w-4 h-4" />
        </button>
      </div>

      <div className="text-white text-lg space-y-4">
        {tabs.map((tab) => (
          <button
            key={tab.name}
            onClick={() => setActiveTab(tab.name)}
            className={`flex items-center gap-4 justify-start px-4 py-2 rounded-lg w-full
              ${
                activeTab === tab.name
                  ? "bg-[linear-gradient(102.15deg,_#FBD150_0%,_#FAB938_100%)] text-black"
                  : "text-gray-200"
              }`}
          >
            {tab.icon}
            {!isCollapsed && <p>{tab.name}</p>}
          </button>
        ))}
      </div>
    </div>
  );
}
